import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '@astro/auth'
import { appUrl } from '@astro/config'
import { isNavLinkActive } from './navActive'
import BrandLogo from './BrandLogo'
import { MdOutlineArrowOutward } from 'react-icons/md'

const NAV_LINKS = [
  { label: 'Home', to: '/', internal: true },
  { label: 'Astrologers', to: '/consultations', internal: true },
  { label: 'Courses', to: appUrl('education'), internal: false },
  { label: 'Horoscope', to: appUrl('website', 'horoscope'), internal: false },
  { label: 'Gallery', to: '/gallery', internal: true },
  { label: 'FAQ', to: '/faq', internal: true },
]

export default function MobileMenu({ drawerOpen, backdropShown, backdropFaded, onClose, onAppt, onVault }) {
  const location = useLocation()
  const { status, login, logout } = useAuth()
  const authed = status === 'authenticated'

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/70 backdrop-blur-sm z-1000 transition-opacity duration-300 ${backdropShown ? '' : 'hidden'
          } ${backdropFaded ? 'opacity-0' : ''}`}
        onClick={onClose}
      />

      <div
        className={`fixed top-0 left-0 bottom-0 w-75 max-w-[85vw] bg-astroDeep/95 backdrop-blur-2xl border-r border-white/5 z-1001 transform transition-transform duration-300 ease-in-out p-8 flex flex-col justify-between shadow-2xl ${drawerOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
      >
        <div className="space-y-8">
          <div className="flex items-center justify-between">
            <Link to="/" onClick={onClose} className="flex items-center gap-2">
              <BrandLogo className="h-10 w-auto max-w-16 rounded-xl sm:h-12 bg-[#FBF3E4] p-1.5 border border-goldPrimary/40 shadow-lg shadow-black/30">
                <div className="w-8 h-8 rounded-full bg-linear-to-tr from-goldAccent to-goldPrimary flex items-center justify-center text-astroDark font-bold text-base shadow-lg">
                  ॐ
                </div>
              </BrandLogo>
              <span className="font-royal text-xs font-bold tracking-widest text-goldPrimary uppercase">
                RAJU MAHARAJ
              </span>
            </Link>
            <button
              type="button"
              onClick={onClose}
              className="text-white/60 hover:text-goldPrimary focus:outline-none"
              aria-label="Close Menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="flex flex-col gap-4 text-left text-xs font-semibold uppercase tracking-widest">
            {NAV_LINKS.map((link) => (
              link.internal ? (
                <Link
                  key={link.label}
                  to={link.to}
                  className={`transition-colors ${isNavLinkActive(link.to, location)
                    ? `text-goldPrimary`
                    : 'text-white hover:text-goldPrimary'
                    }`
                  }
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.to}
                  className={`transition-colors flex items-center text-white hover:text-goldPrimary`}
                >
                  {link.label} <MdOutlineArrowOutward />
                </a>
              )
            ))}
            {/* Dashboard lives in the website app — cross-app link. Signed-in only. */}
            {authed && (
              <a
                href={appUrl('website', '/dashboard')}
                onClick={onClose}
                className="text-white/80 hover:text-goldPrimary py-2 border-b border-white/5"
              >
                Dashboard
              </a>
            )}
            {/* Session row — Logout when signed in, Login otherwise. */}
            <button
              type="button"
              onClick={() => { onClose(); authed ? logout() : login() }}
              className="text-left text-white/80 hover:text-goldPrimary py-2 border-b border-white/5 cursor-pointer text-xs font-semibold uppercase tracking-widest"
            >
              {authed ? 'Logout' : 'Login'}
            </button>
          </div>

          <div className="space-y-4 pt-4">
            <p className="text-[9px] uppercase tracking-widest text-white/40 font-bold mb-2">Vedic Shortcuts</p>
            <div className="grid grid-cols-3 gap-2">
              <button
                type="button"
                onClick={onAppt}
                className="bg-white/5 border border-white/5 hover:border-goldPrimary/30 rounded-xl p-3 flex flex-col items-center gap-1.5 transition-all"
              >
                <span className="text-base">📅</span>
                <span className="text-[8px] uppercase tracking-widest text-white/50">APPT</span>
              </button>
              <button
                type="button"
                onClick={onVault}
                className="bg-white/5 border border-white/5 hover:border-goldPrimary/30 rounded-xl p-3 flex flex-col items-center gap-1.5 transition-all"
              >
                <span className="text-base">🔐</span>
                <span className="text-[8px] uppercase tracking-widest text-white/50">VAULT</span>
              </button>
              <a
                href="tel:+919062277590"
                className="bg-white/5 border border-white/5 hover:border-goldPrimary/30 rounded-xl p-3 flex flex-col items-center gap-1.5 transition-all text-center"
              >
                <span className="text-base">📞</span>
                <span className="text-[8px] uppercase tracking-widest text-white/50">CALL</span>
              </a>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <Link
            to="/#our-astrologers"
            onClick={onClose}
            className="block w-full text-center bg-linear-to-r from-goldAccent to-goldPrimary text-astroDark font-bold py-3 rounded-xl shadow-lg text-xs tracking-wider uppercase"
          >
            Book Appointment
          </Link>
          <p className="text-[9px] text-white/30 text-center font-light">Protected under Vedic Discretion standard.</p>
        </div>
      </div>
    </>
  )
}
